import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'
import { Button } from 'blaze-ui/Button'
import { Menu } from 'components/Menu/Menu'
import { WeekDay, WeekDays } from 'types'
import {
  ONLY_WEEK_DAYS,
  ONLY_WEEKENDS,
  WEEK_DAYS,
} from 'screens/VirtualMarketerOnboarding/CustomizeSchedule/CustomizeSchedule'
import { Item } from '@react-stately/collections'
import { useField } from 'formik'
import { useMemo } from 'react'

export const PostDaysField = () => {
  const [{ value: weekDays }, , { setValue: setWeekDays }] = useField<WeekDays>('week_days')

  let selectDaysLabel = useMemo(() => {
    if (weekDays.length < 1) return 'Select days'
    if (weekDays.length === WEEK_DAYS.length) return 'Everyday'
    if (weekDays.length === ONLY_WEEK_DAYS.length && ONLY_WEEK_DAYS.every((day) => weekDays.includes(day)))
      return 'Weekdays'
    if (weekDays.length === ONLY_WEEKENDS.length && ONLY_WEEKENDS.every((day) => weekDays.includes(day)))
      return 'Weekends'
    return 'Custom'
  }, [weekDays])

  return (
    <DropdownTrigger placement="bottom-start">
      <Button variant="secondary" size="lg" aria-label="Select Days">
        {selectDaysLabel}
      </Button>
      <Menu
        onAction={(key) => {
          const newSelectedDays = new Set(weekDays)
          if (newSelectedDays.has(key as WeekDay)) {
            newSelectedDays.delete(key as WeekDay)
          } else {
            newSelectedDays.add(key as WeekDay)
          }
          setWeekDays([...newSelectedDays])
        }}
        selectionMode="multiple"
        selectedKeys={weekDays}
        showCheckmark
        aria-label="Select days"
      >
        {WEEK_DAYS.map((day) => (
          <Item key={day} textValue={day}>
            {day}
          </Item>
        ))}
      </Menu>
    </DropdownTrigger>
  )
}
